export default __webpack_public_path__ + "static/media/gin.e009fc77.md";